export class ProfileContractCallError extends Error {
  // This gives the error type safety
  private readonly typeName = 'ProfileContractCallError'
  public readonly name = this.typeName

  constructor(contractName: string, message: string) {
    super(
      `Error calling ${contractName} contract in profile subdomain: ${message}`
    )
  }
}
